import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab"]

  connect() {
    this.updateActiveTab()
    document.addEventListener('turbo:frame-render', this.handleFrameRender.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:frame-render', this.handleFrameRender.bind(this))
  }

  handleFrameRender() {
    setTimeout(() => this.updateActiveTab(), 100)
  }

  selectTab(event) {
    const clickedTab = event.currentTarget

    this.setActiveTab(clickedTab)
  }

  setActiveTab(activeTab) {
    this.tabTargets.forEach(tab => {
      tab.classList.remove('border-indigo-500', 'text-indigo-600')
      tab.classList.add('border-transparent', 'text-gray-500')
    })

    activeTab.classList.remove('border-transparent', 'text-gray-500')
    activeTab.classList.add('border-indigo-500', 'text-indigo-600')
  }

  updateActiveTab() {
    const urlParams = new URLSearchParams(window.location.search)
    const objectId = urlParams.get('object_id')

    let activeTab = null

    if (objectId) {
      activeTab = this.tabTargets.find(tab => tab.dataset.objectId === objectId)
    }

    if (!activeTab && this.tabTargets.length > 0) {
      activeTab = this.tabTargets[0]
    }

    if (activeTab) {
      this.setActiveTab(activeTab)
    }
  }
}